<template>
  <section id="setup" class="container">
    <section
      v-if="step === 1"
      id="setup-content"
      class="box padding w-buttons install step1"
    >
      <div class="w100 txt-center">
        <h1>Precisamos completar seu cadastro!</h1>
        <p class="margin-top-m">
          Preencha as informações abaixo para iniciar sua jornada na
          <b>123 Mail!</b>
        </p>
      </div>

      <validation-observer ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(updateAccount)">
          <div class="box-content">
            <validation-provider
              name="Nome da Conta"
              rules="required"
              v-slot="{ errors }"
            >
              <div
                class="form-field flex-1 w100 group-input margin-top-m"
                :class="{ errors: errors[0] }"
              >
                <label>Nome da Conta</label>
                <input class="input" type="text" v-model="account.name" />
                <span class="erros-alert">{{ errors[0] }}</span>
              </div>
            </validation-provider>

            <div class="flex-1 w100 margin-top-l">
              <div class="flex center">
                <div class="flex-1 switcher">
                  <input
                    type="radio"
                    id="CNPJ"
                    v-model="documentType"
                    value="CNPJ"
                  />
                  <label for="CNPJ">CNPJ</label>
                  <input
                    type="radio"
                    id="CPF"
                    v-model="documentType"
                    value="CPF"
                  />
                  <label for="CPF">CPF</label>
                </div>
              </div>
            </div>
            <div
              v-if="documentType === 'CNPJ'"
              class="flex-1 w100 margin-top-m"
            >
              <validation-provider
                name="CNPJ"
                rules="required"
                v-slot="{ errors }"
              >
                <div
                  class="form-field flex-1 w100 group-input margin-top-m"
                  :class="{ errors: errors[0] }"
                >
                  <label>CNPJ</label>
                  <the-mask
                    :mask="['##.###.###/####-##']"
                    v-model="document"
                    placeholder="XX.XXX.XXX/XXXX-XX"
                    class="input"
                  />
                  <span class="erros-alert">{{ errors[0] }}</span>
                </div>
              </validation-provider>
              <validation-provider
                name="Razão Social"
                rules="required"
                v-slot="{ errors }"
              >
                <div
                  class="form-field flex-1 w100 group-input margin-top-m"
                  :class="{ errors: errors[0] }"
                >
                  <label>Razão Social</label>
                  <input
                    class="input"
                    type="text"
                    v-model="corporateName"
                    placeholder=""
                  />
                  <span class="erros-alert">{{ errors[0] }}</span>
                </div>
              </validation-provider>
            </div>
            <div v-else class="flex-1 w100 margin-top-m">
              <validation-provider
                name="CPF"
                rules="required"
                v-slot="{ errors }"
              >
                <div
                  class="form-field flex-1 w100 group-input margin-top-m"
                  :class="{ errors: errors[0] }"
                >
                  <label>CPF</label>
                  <the-mask
                    :mask="['###.###.###-##']"
                    v-model="document"
                    placeholder="XXX.XXX.XXX-XX"
                    class="input"
                  />
                  <span class="erros-alert">{{ errors[0] }}</span>
                </div>
              </validation-provider>
              <validation-provider
                name="Nome Completo"
                rules="required"
                v-slot="{ errors }"
              >
                <div
                  class="form-field flex-1 w100 group-input margin-top-m"
                  :class="{ errors: errors[0] }"
                >
                  <label>Nome Completo</label>
                  <input
                    class="input"
                    type="text"
                    v-model="corporateName"
                    placeholder=""
                  />
                  <span class="erros-alert">{{ errors[0] }}</span>
                </div>
              </validation-provider>
            </div>
          </div>
          <div class="buttons flex center">
            <button type="submit" class="button primary medium">
              INICIAR JORNADA
            </button>
          </div>
        </form>
      </validation-observer>
    </section>
  </section>
</template>

<script>
import { mapState } from "vuex";

import { Account, updateAccount } from "@/services/account";

export default {
  name: "Onboarding",
  props: {
    msg: String,
  },
  data() {
    return {
      step: 1,
      documentType: "CNPJ",
      document: "",
      corporateName: "",
    };
  },
  mounted() {
    this.getAccountInfo();
  },
  watch: {
    documentType() {
      this.document = "";
      this.corporateName = "";
    },
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
  },
  methods: {
    getAccountInfo() {
      Account().then((result) => {
        this.$store.dispatch("setAccount", result);
      });
    },
    updateAccount() {
      let params = {
        name: this.account.name,
        document: this.document,
        document_type: this.documentType,
        corporate_name: this.corporateName,
      };
      updateAccount(params)
        .then((result) => {
          this.$toast.success({
            title: "Sucesso",
            message: "Conta atualizada com sucesso",
          });

          this.$store.dispatch("setAccount", result);
          this.$router.push({ name: "Home" });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao atualizar conta",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
#setup {
  margin-top: 100px;
  label {
    font-weight: 800;
  }
}
</style>
